// src/components/NavBar/NavBarComponent.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../Context/UserContext';
import { signOut } from 'aws-amplify/auth';
import AccordiaLogo from '../../assets/accordia_logo512x512.png';
import styles from './NavBarComponent.module.css';

const FALLBACK_DOT =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

// image in /public, served from the root
const WORDMARK_SRC = '/Accordia80x212nav.png';

export default function NavBarComponent() {
  const navigate = useNavigate();
  const { isAuthenticated, refreshUser } = useUserContext();

  useEffect(() => {
    void refreshUser();
  }, [refreshUser]);

  const logoSrc =
    typeof AccordiaLogo === 'string' && AccordiaLogo.length > 0
      ? AccordiaLogo
      : FALLBACK_DOT;

  const handleLogin = () => navigate('/login');
  const handleStart = () => navigate('/register');

  const handleLogout = async () => {
    try {
      await signOut();
      await refreshUser();
    } finally {
      navigate('/');
    }
  };

  return (
    <header className={`${styles.navbar} ${styles.sticky} ${styles.navbarLight}`}>
      {/* Left: Logo + brand */}
      <div
        className={styles.navLeft}
        onClick={() => navigate('/')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && navigate('/')}
      >
        <img
          src={logoSrc}
          alt="Accordia icon"
          className={styles.navLogo}
        />
        <img
          src={WORDMARK_SRC}
          alt="Accordia wordmark"
          className={styles.navWordmark}
        />
      </div>

      {/* Right: CTAs */}
      <div className={styles.navRight}>
        {!isAuthenticated ? (
          <>
            <button className={styles.btnGhost} onClick={handleLogin}>
              Log in
            </button>
            <button className={styles.btnPrimary} onClick={handleStart}>
              Start for Free
            </button>
          </>
        ) : (
          <button className={styles.btnGhost} onClick={handleLogout}>
            Log out
          </button>
        )}
      </div>
    </header>
  );
}
